import { ArrowRightIcon } from '@heroicons/react/outline';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Elements/Button/Button';

export type HelpContainerProps = {
  onClick: () => void;
  className?: string;
};

export const HelpContainer = ({ onClick, className = '' }: HelpContainerProps) => {
  const { t } = useTranslation();

  return (
    <section
      className={`${className} h-auto lg:h-[625px] max-w-6xl m-auto px-3 py-2 lg:px-8 lg:py-10 text-center lg:text-left relative`}
    >
      <div className="z-40 relative h-full">
        <h3 className="md__payments__container--h3">{t('HelpContainer.title')}</h3>
        <p className="text-lg lg:text-xl w-full lg:w-1/2 text-md-black lg:leading-8 font-thin">
          {t('HelpContainer.description')}
        </p>
        <Button
          className="m-auto mt-10 lg:mx-0 py-2 lg:py-4 text-xs lg:text-sm w-[300px]"
          variant="primary"
          type="button"
          title={t('HelpContainer.actionButton')}
          onClick={onClick}
          endIcon={<ArrowRightIcon className="h-5 w-5 text-white mr-6" aria-hidden="true" />}
        >
          {t('HelpContainer.actionButton')}
        </Button>
      </div>
      <div className="md__help__container__picture absolute hidden lg:block bottom-0 left-0 right-0 top-[50px]" />
    </section>
  );
};
